import { render } from "./ExternalLink2Icon.vue?vue&type=template&id=3438b28f"
import script from "./ExternalLink2Icon.vue?vue&type=script&lang=js"
export * from "./ExternalLink2Icon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__